import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import axios from "axios";
import { Avatar } from "@/components/Avatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LINKS = [
    { to: "/dashboard", label: "Memories", testid: "nav-memories" },
    { to: "/milestones", label: "Milestones", testid: "nav-milestones" },
    { to: "/family", label: "Family", testid: "nav-family" },
    { to: "/activity", label: "Activity", testid: "nav-activity" },
];

export function AppHeader({ user }) {
    const navigate = useNavigate();
    const logout = async () => {
        try {
            await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
        } catch {}
        navigate("/");
    };
    const navClass = ({ isActive }) =>
        `rounded-full px-4 py-2 text-xs font-semibold transition-colors duration-300 ${
            isActive ? "bg-navy text-white" : "text-navy hover:bg-ivory"
        }`;
    return (
        <header data-testid="app-header" className="sticky top-0 z-40 border-b border-warmgray bg-cream/80 backdrop-blur-xl">
            <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
                <div className="flex items-center gap-6">
                    <Link to="/dashboard" data-testid="app-logo" aria-label="Ago GenApp dashboard">
                        <img src="/logo.png" alt="Ago GenApp" className="h-9 w-auto" />
                    </Link>
                    <nav className="hidden items-center gap-1 sm:flex">
                        {LINKS.map((l) => (
                            <NavLink key={l.to} to={l.to} data-testid={l.testid} className={navClass}>
                                {l.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
                <div className="flex items-center gap-3">
                    <span className="hidden items-center gap-2.5 md:flex">
                        <Avatar person={user} size={28} />
                        <span className="text-sm font-medium text-navy">{user.name || user.email}</span>
                    </span>
                    <button
                        data-testid="app-logout"
                        onClick={logout}
                        aria-label="Sign out"
                        className="text-navy/70 transition-colors duration-300 hover:text-navy"
                    >
                        <LogOut size={18} />
                    </button>
                </div>
            </div>
            <nav className="flex items-center gap-1 overflow-x-auto border-t border-warmgray px-4 py-2 sm:hidden">
                {LINKS.map((l) => (
                    <NavLink key={l.to} to={l.to} data-testid={`${l.testid}-mobile`} className={navClass}>
                        {l.label}
                    </NavLink>
                ))}
            </nav>
        </header>
    );
}
